import React                                                            from 'react';
import { BasicDialog }                                                  from '../../../components/modals/BasicDialog';
import { Align, SemanticUIColor, Size, Uuid, }                          from '../../../../types';
import { BasicDialogContainer }                                         from '../../../components/modals/BasicDialogContainer';
import { CompareProjectTool, CompareProjectToolProps, CompareToolType } from '../common/visualization/tools/compare-projects/CompareProjectTool';

interface CompareProjectDialogProps<T = never> extends CompareProjectToolProps {
	
	projectIds: Uuid[],
	title?: string,
	primaryProjectId?: null
	
}

function CompareProjectDialog<T>( { projectIds = null, title, primaryProjectId }: CompareProjectDialogProps<T> ){
	
	return (
		<BasicDialog
			showSubmitButton={ false }
			controlAlign={ Align.CENTER }
			className={ 'no-padding' }
			cancelLabel={ 'Close' }>
			
			<BasicDialogContainer title={ title } titleColor={ SemanticUIColor.PURPLE } contentPadding={ Size.MD }>
				
				<CompareProjectTool
					projectIds={ projectIds }
					primaryProjectId={ primaryProjectId }
				/>
			
			</BasicDialogContainer>
		
		</BasicDialog>
	);
}

export { CompareProjectDialog };
